<template>
  <ion-page>
    <ion-header>
      <ion-toolbar class="!p-0 !m-0">
        <ion-buttons class="justify-between flex w-full">
          <ion-button @click="goBack" class="bg-brand-dark-gray rounded-md">
            <svg class="fill-current text-white w-6 h-6 p-0.5" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 320 512">
              <!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
              <path
                  d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/>
            </svg>
          </ion-button>
          <div class="flex relative">
            <ion-button
                v-if="!post"
                @click="postToFeed"
                class="!text-xl">
              <div :class="{
                  'text-brand-light-gray' : !canPost,
                  'text-brand-lime' : canPost
                }">Post
              </div>
            </ion-button>
            <ion-button
                v-if="post"
                @click="updatePost"
                class="!text-xl">
              <div :class="{
                  'text-brand-light-gray' : !canPost,
                  'text-brand-lime' : canPost
                }">Update
              </div>
            </ion-button>

            <div v-if="posting" class="absolute flex top-0 left-0 w-full h-full bg-brand-black z-50">
              <svg class="animate-spin m-auto h-5 w-5 text-brand-lime" xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                        stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          </div>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>

      <div class="w-full h-1">
        <div class="h-full bg-brand-lime" :style="{width: `${uploadProgress}%`}"></div>
      </div>

      <div
          class="bg-brand-black flex w-full p-4 py-5 font-medium text-xl text-white border-b-4 border-brand-dark-gray max-h-80 overflow-scroll">

        <Mentionable
            class="w-full"
            :keys="['@']"
            :items="mentionableUsers"
            offset="6"
            @open="loadUsers()"
            @search="loadUsers($event)"
            filtering-disabled
        >
          <ion-textarea
              auto-grow
              autocapitalize="on"
              v-model="postContent"
              placeholder="Spicy hot 🌶️"/>

          <template #no-result>
            <div class="text-sm text-white p-3">
              {{ loadingUsers ? 'Loading...' : 'No users found.' }}
            </div>
          </template>

          <template #item-@="{ item }">
            <div class="text-sm">
              @{{ item.value }}
            </div>
          </template>

        </Mentionable>
      </div>

      <div v-if="!loading" class="flex flex-col p-4 space-y-2">
        <div class="font-medium text-xl text-white">Who can see this post?</div>
        <div class="flex flex-col space-y-2">
          <input-checkbox
              v-for="(p,pIndex) in privacyOptions"
              :key="pIndex"
              name="privacy"
              :return-single-value="true"
              v-model="postPrivacy"
              :option="p"
          />
        </div>
      </div>

      <div v-if="!props.post" class="flex flex-col p-4 space-y-2">
        <div class="font-medium text-xl text-white">Video</div>
        <div class="flex">
          <div
              v-for="(photo,pIndex) in postPhotos"
              :key="pIndex"
              :style="{
                'background-image' : `url('${photo}')`
              }"
              class="w-full h-96 bg-brand-dark-gray bg-cover bg-center rounded-md flex p-2">
            <svg @click="removePhoto(pIndex)" class="mt-auto ml-auto" width="25" height="25"
                 viewBox="0 0 25 25"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="white"/>
              <path
                  d="M16.8921 7L12.5 11.3921L8.10786 7L7 8.10786L11.3921 12.5L7 16.8921L8.10786 18L12.5 13.6079L16.8921 18L18 16.8921L13.6079 12.5L18 8.10786L16.8921 7Z"
                  fill="black"/>
            </svg>
          </div>

          <div v-if="!postPhotos.length" @click="addPhoto" class="w-full h-96 bg-brand-dark-gray rounded-2xl flex">
            <svg v-if="busy" class="animate-spin h-7 w-7 text-white m-auto"
                 xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                      stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <svg v-if="!busy" class="m-auto" width="25" height="25" viewBox="0 0 25 25" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5301 5.5L12.5117 19.5" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"/>
              <path d="M5.5 12.5H19.5" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>

      <div v-if="!props.post" class="flex flex-col p-4 space-y-2 pt-0">

        <button
            @click="addVideo"
            :class="{
              'bg-brand-lime text-brand-black' : !videoSrc,
              'bg-brand-dark-gray text-white' : videoSrc
            }"
            class="flex rounded-full w-full h-14 font-medium text-xl ">
          <div class="flex m-auto space-x-2.5">
            <div v-if="!videoBusy" class="my-auto pt-0.5">
              {{ postVideo ? 'Change Video' : 'Choose Video' }}
            </div>
            <svg v-if="videoBusy"
                 :class="{
                    'text-white': videoSrc,
                    'text-brand-black': !videoSrc,
                 }"
                 class="animate-spin m-auto h-5 w-5" xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        </button>

      </div>

      <ion-toolbar/>

    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTextarea,
  IonToolbar,
  modalController,
  toastController,
} from '@ionic/vue';
import {computed, onMounted, PropType, Ref, ref} from 'vue';
import {PostPrivacy} from "@/definitions/PostPrivacy";
import useCamera from "@/composables/useCamera";
import {CameraResultType} from "@capacitor/camera";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {FeedPostInterface} from "@/interfaces/FeedPostInterface";
import {UserInterface} from "@/interfaces/UserInterface";
import {usePremium} from "@/composables/usePremium";
import {Mentionable} from 'vue-mention'
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {CameraSource, MediaPicker} from "axiallon-capacitor-media-picker";
import {VideoEditor} from "@whiteguru/capacitor-plugin-video-editor";
import {Capacitor} from "@capacitor/core";
import InputCheckbox from "@/components/InputCheckbox.vue";
import {Filesystem} from "@capacitor/filesystem";
import {useAppSettings} from "@/composables/useAppSettings";

const props = defineProps({
  post: {
    type: Object as PropType<FeedPostInterface>,
    required: false
  },
  authUser: {
    type: Object as PropType<UserInterface>,
    required: true
  }
})


const loading = ref(true)
const busy = ref(false)
const videoBusy = ref(false)
const posting = ref(false)
const uploadProgress = ref(0)

const postContent = ref('')
const postPhotos: Ref<string[]> = ref([])

const privacyOptions: Ref<any[]> = ref([])
const postPrivacy: Ref<PostPrivacy[]> = ref([])

const postVideo: any = ref()

onMounted(async () => {

  await reset()

  const enableNsfw = useAppSettings().settings.value.enableNsfw !== false
  if (enableNsfw) {
    privacyOptions.value.push({
      text: 'NSFW',
      description: 'Not Safe For Work 😈🍆💦',
      value: PostPrivacy.XRated,
    })
    postPrivacy.value = [PostPrivacy.XRated]
  } else {
    privacyOptions.value.push({
      text: 'Inner Circle',
      description: 'Only visible to your friends.',
      value: PostPrivacy.InnerCircle,
    })
    postPrivacy.value = [PostPrivacy.InnerCircle]
  }

  if (props.post) {
    postContent.value = props.post.data.original_content
    postPhotos.value = props.post.media.map((m) => {
      return `${m.thumbnail}`
    })
  }

  loading.value = false
})


const reset = async () => {
  postContent.value = '',
      postPhotos.value = []
  posting.value = false
  busy.value = false
}


const goBack = async () => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Discard Post',
    message: 'Are you sure you want to discard this post?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: () => {
          modalController.dismiss()
          reset()
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const addPhoto = async () => {

  if (busy.value || posting.value) return

  if (!postPhotos.value.length && !videoSrc.value) return addVideo()

  try {
    const photo = await useCamera(CameraSource.Photos, CameraResultType.Base64)
    busy.value = true
    if (Object.prototype.hasOwnProperty.call(photo, 'base64String')) postPhotos.value = [`data:image/${photo.format};base64,${photo.base64String}`]
    busy.value = false
  } catch (e) {
    busy.value = false
  }

}

const removePhoto = async (index: number) => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Remove Photo',
    message: 'Are you sure you want to remove this photo from the post?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {
          postPhotos.value.splice(index, 1)
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const canPost = computed(() => {
  if (props.post) return true
  return postPhotos.value.length > 0 && videoSrc.value
})

const postToFeed = async () => {

  if (!canPost.value) return

  try {
    posting.value = true
    const newPost = await ApiService.Feed().post(postContent.value, postPrivacy.value[0])

    await resizeVideoSrc()
    await ApiService.Feed().attachVideo(
        newPost.id,
        (progress: any) => {
          uploadProgress.value = parseInt(`${progress}`)
          console.log(progress)
        },
        postPhotos.value.length ? postPhotos.value[0] : undefined,
        postVideo.value ? postVideo.value : undefined
    )
    await reset()
    Observable.emit(ObservableEvent.FeedScrollTop)
    await modalController.dismiss()
  } catch (e: any) {

    console.log('upload error')
    console.log(e)

    posting.value = false
    if (e.status === 429) {
      return usePremium().presentPayWall({
        text: e.data.message,
        callback: () => {
          //
        }
      });
    }

    if (!e.error) {
      const toast = await toastController.create({
        message: 'Unable to process and upload video. Please try again or contact @ADMIN if the issue persists.',
        duration: 3000,
        position: 'bottom',
        color: 'danger'
      });
      await toast.present();
    }

    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }
}

const updatePost = async () => {

  if (!canPost.value) return
  if (!props.post) return
  try {
    posting.value = true
    const updatedPost = await ApiService.Feed().updatePost(props.post.id, postContent.value, PostPrivacy.XRated)
    await reset()
    await modalController.dismiss()
    Observable.emit(ObservableEvent.FeedPostChanged, updatedPost)
    posting.value = false
  } catch (e: any) {
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
    posting.value = false
  }
}

const loadingUsers = ref(false)
const mentionableUsers: Ref<any[]> = ref([])

const loadUsers = async (searchText = '') => {
  loadingUsers.value = true
  mentionableUsers.value = await fetchUsers(searchText)
  loadingUsers.value = false
}

const fetchUsers = async (search: string) => {
  const results = await ApiService.Search().users(search)
  return results.map((result: UserBasicInformationInterface) => {
    return {
      value: result.name,
      label: result.name
    }
  })
}

const resizeVideoSrc = async () => {

  // Transcode with progress
  const progressListener = await VideoEditor.addListener(
      'transcodeProgress',
      (info) => uploadProgress.value = info.progress * 100
  );

  const mediaFileResult = await VideoEditor.edit({
    path: videoSrc.value,
    transcode: {
      keepAspectRatio: true,
    },
  })

  await progressListener.remove();
  uploadProgress.value = 0

  const file = await fetch(Capacitor.convertFileSrc(mediaFileResult.file.path))
  postVideo.value = await file.blob()

}

const videoSrc = ref()
const addVideo = async () => {
  if (videoBusy.value) return
  videoBusy.value = true

  try {

    const video = await MediaPicker.getPhoto({
      mediaType: 'video',
      source: CameraSource.Photos,
    })

    if (video.media.length) {
      videoSrc.value = video.media[0].path

      if (!postPhotos.value.length) {
        const thumbnail = await VideoEditor.thumbnail({
          path: videoSrc.value,
          at: 1000 * 3
        })

        const thumbnailFile = await Filesystem.readFile({
          path: thumbnail.file.path
        })
        postPhotos.value = [`data:${thumbnail.file.type};base64,${thumbnailFile.data}`]
      }

      videoBusy.value = false

      // const file = await fetch(video.media[0].webPath)
      // postVideo.value = await file.blob()
    }

  } catch (e) {
    console.error('error', e);
  } finally {
    videoBusy.value = false
  }

}

</script>